import React from "react";

import ShipeeziGrid, { Column, GeneralActions } from "Components/AppGrid/shipeezi-new-grid";
import _ from "lodash";
import { useTranslation } from "react-i18next";

import { useLanguageHook } from "../../../../../../../../../hooks/useLanguageHook";
import { Searches } from "../../../../../../../../../models/shipeezi.table";
import { User } from "../../../../../../../../../models/user";
import { Input } from "../../../../../../../../../components/Form";
import { useTranslationStyles } from "./styles";
import { formatDateWithUserPref } from "Util/dateFormaterPreference";
import { useAppState } from "Context/StateContext";

const TranslationForm: React.FC = () => {
  const classes = useTranslationStyles();
  const { t: translate } = useTranslation();

  const {
    pageTranslate,
    pageTranslateSize,
    translateTotal,
    isFetchingTranslate,
    translateLanguages,
    setPageTranslate,
    setTranslateLanguages,
    handleUpdateTranslate,
    setSearches,
    setPageTranslateSize,
    setCurrentTranslatePage,
  } = useLanguageHook();

  const { currentUser } = useAppState();

  const handleSearch = (value: Searches) => {
    if (setSearches) setSearches(value);
    if (setPageTranslate) setPageTranslate(0);
  };

  const showTermField = (value?: string) => {
    const translateLang = translateLanguages?.find((item) => item?.key === value);

    if (translateLang) {
      return (
        <Input
          name="termField"
          value={translateLang?.value}
          placeholder={translate("thisIsTheName")}
          data-cy={`translateInput-${translateLang.id}`}
          onChange={(event) => {
            const langs = translateLanguages ? _.cloneDeep(translateLanguages) : [];
            const index = langs.findIndex((lang) => lang.key === translateLang.key);

            if (index !== -1) {
              if (langs[index]) {
                langs[index].value = event.target.value;

                handleUpdateTranslate(langs[index]);
              }
            }

            setTranslateLanguages([...langs]);
          }}
        />
      );
    }
  };

  const columns: Column[] = [
    {
      name: "key",
      title: translate("term"),
      formatComponent: showTermField,
      searchIdentifier: "value",
    },
    {
      name: "user",
      title: translate("createdBy"),
      hideSort: true,
      hideSearch: true,
      formatText: (user: User) => `${user?.name ?? ""} ${user?.lastName ?? ""}`,
    },
    {
      name: "updatedAt",
      title: translate("lastUpdate"),
      hideSearch: true,
      formatText: (date?: Date) => {
        return date && currentUser?.preferences
          ? formatDateWithUserPref(date, currentUser.preferences)
          : "-";
      },
    },
  ];

  const generalActions: GeneralActions = {
    orderBy: {
      left: ["handleSearch"],
    },
    handleSearch: {
      onSearch: handleSearch,
    },
  };

  return (
    <div className={classes.tableWrapper}>
      <ShipeeziGrid
        columns={columns}
        data={translateLanguages || []}
        totalItems={translateTotal}
        loadingData={isFetchingTranslate}
        pageSize={pageTranslateSize}
        pageSizeList={[20, 40, 60, 100]}
        currentPage={pageTranslate}
        onChangePageSize={setPageTranslateSize}
        onNextPage={setCurrentTranslatePage}
        onPreviousPage={setCurrentTranslatePage}
        onGoToPage={setCurrentTranslatePage}
        generalActions={generalActions}
        emptyData={translate("noInformationToBeShown")}
        showSelection={false}
        showFooterGrid
      />
    </div>
  );
};

export default TranslationForm;
